import type { T_ShopLoyaltyConfigResponse } from '@/types/Shopify';
import { E_EnableLoyaltyProgramName } from '@/types/Shopify';

const hasProgram = (
  programs: T_ShopLoyaltyConfigResponse['loyaltyPrograms'],
  programName: E_EnableLoyaltyProgramName,
) => programs.some(({ name }) => name === programName);

export const getProgramDescription = (
  programs: T_ShopLoyaltyConfigResponse['loyaltyPrograms'],
  programName: E_EnableLoyaltyProgramName,
) => programs?.find(({ name }) => name === programName)?.description;

export const hasTiersProgram = (programs: T_ShopLoyaltyConfigResponse['loyaltyPrograms']) =>
  hasProgram(programs, E_EnableLoyaltyProgramName.TIERS_PROGRAM);

export const hasPointsProgram = (programs: T_ShopLoyaltyConfigResponse['loyaltyPrograms']) =>
  hasProgram(programs, E_EnableLoyaltyProgramName.POINTS_PROGRAM);

export const hasPunchCardsProgram = (programs: T_ShopLoyaltyConfigResponse['loyaltyPrograms']) =>
  hasProgram(programs, E_EnableLoyaltyProgramName.PUNCH_CARDS_PROGRAM);

export const hasCouponsProgram = (programs: T_ShopLoyaltyConfigResponse['loyaltyPrograms']) =>
  hasProgram(programs, E_EnableLoyaltyProgramName.COUPONS_PROGRAM);
